import { Component, inject, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { ProfileService } from '@tfs/auth';
import { TfsIconDirective } from '@tfs/material/tfs-icon';
import { AssemblyQuotaIndicatorComponent } from '@tfs/shared-ui/assembly-quota-indicator/assembly-quota-indicator.component';
import { SubscriptionStatusComponent } from '@tfs/user-subscription-status';

@Component({
  selector: 'app-profile-panel',
  imports: [
    MatButtonModule,
    MatListModule,
    MatTooltipModule,
    RouterModule,
    TfsIconDirective,
    SubscriptionStatusComponent,
    AssemblyQuotaIndicatorComponent,
    MatIconModule,
  ],
  templateUrl: './profile-panel.component.html',
  styleUrl: './profile-panel.component.scss',
})
export class ProfilePanelComponent {
  protected readonly isSubscriptionInactive = inject(ProfileService).isSubscriptionInactive;
  protected readonly inactiveTooltip =
    'Subscription inactive. Please renew to access this feature.';

  readonly closePanel = output();
  readonly logout = output();

  protected onClose(): void {
    this.closePanel.emit();
  }

  protected onLogout(): void {
    this.logout.emit();
    this.closePanel.emit();
  }

  protected onSettingsClick(): void {
    this.closePanel.emit();
  }
}
